const LOCALSTORAGE_OVER_18_YEARS_OLD = 'over_18_years_old';
const setSessionStorageOver18YearOld = (value) => {
    if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(LOCALSTORAGE_OVER_18_YEARS_OLD, JSON.stringify(value));
    }
};
const getSessionStorageOver18YearOld = () => {
    if (typeof sessionStorage !== 'undefined') {
        return sessionStorage.getItem(LOCALSTORAGE_OVER_18_YEARS_OLD) === 'true';
    }
    return false;
};

export { LOCALSTORAGE_OVER_18_YEARS_OLD, getSessionStorageOver18YearOld, setSessionStorageOver18YearOld };
